import React from "react";
import PropTypes from "prop-types";
import styles from "./DocumentsList.module.css";

import DocumentItem from "../../Shared/DocumentItem";
import PdfIcon from "../../assets/file-light.svg";

/**
 * Interactive component.
 * Displays the documents under the documents tab on the EventDetails page.
 */
export function DocumentsList({ onUpload, documents }) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p>Documents</p>
        <button className={styles["upload-button"]} onClick={onUpload}>
          Upload
        </button>
      </div>
      <ul className={styles["document-list"]}>
        {documents.map((item) => (
          <li>
            <DocumentItem {...item} icon={PdfIcon} />
          </li>
        ))}
      </ul>
    </div>
  );
}

DocumentsList.propTypes = {
  /**
   * Function called when upload is clicked.
   */
  onUpload: PropTypes.func,
  /**
   * Array of document items to display.
   */
  documents: PropTypes.array,
};

DocumentsList.defaultProps = {
  documents: [],
};
